export const dateFormat = 'DD-MM-YYYY';
export const dateFormatApi = 'YYYY-MM-DD';
export const dateFormatInitDate = 'yyyy-MM-DD';

// Leverandør:
export const projectTypeId = 2;
// Prosjekt:
export const supplierTypeId = 1;
